export default {
  cancelButton: 'Cancelar',
  dateRangeLabel: 'Intervalo de tiempo *',
  periods: {
    today: 'Hoy',
    yesterday: 'Ayer',
    last24hours: 'Últimas 24 horas',
    currentWeek: 'Semana actual',
    currentMonth: 'Mes actual',
    lastMonth: 'Mes pasado',
    last7days: 'Últimos 7 días',
    last30days: 'Últimos 30 días',
  },
  previousPeriods: {
    today: 'ayer',
    yesterday: 'anteayer',
    last24hours: 'en las 24 horas anteriores',
    currentWeek: 'la semana pasada',
    currentMonth: 'el mes pasado',
    lastMonth: 'el mes anterior',
    last7days: 'en los 7 días anteriores',
    last30days: 'en los 30 días anteriores',
    custom: 'en el mismo intervalo anterior',
  },
};
